/** @jsxImportSource @emotion/react */

import React from 'react'

import { grey } from '@mui/material/colors'

interface PropsType {
	name: string
	className?: string
	style?: React.CSSProperties
	strokeColor?: string
	strokeWidth?: string
}

export const Icon = (props: PropsType) => {
	return (
		<span
			className={`mdi mdi-${props.name} ${props.className ?? ''}`}
			css={[
				{ color: grey[800], fontSize: 20, textStrokeWidth: '1px' },
				{ ...props.style },
			]}
		/>
	)
}
